module.exports = __webpack_public_path__ + "img/39c6e22.png";